module.exports = require('./helpers/bundle-url').getBundleURL('hglyI') + "logo.c51670a8.svg";